import Login from '../../views/Login.vue';
import PasswordReset from '../../views/password-reset';
import NewPassword from '../../views/new-password';
import LoginThirdParty from '../../views/LoginThirdParty.vue';

export default [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/login/office365',
        name: 'login365',
        component: Login
    },
    {
        path: '/login-third-party',
        name: 'login-third-party',
        component: LoginThirdParty
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset
    },
    {
        path: '/new-password',
        name: 'new-password',
        component: NewPassword
    }
];
